import { listAllKeys, localStorage } from 'helpers/localStorage'
import { wlsly } from 'helpers/wlsly'
import { AUTH_TOKEN_NAME } from '../token'

const storage = localStorage()

const clearAllStorage = async () => {
  try {
    listAllKeys().forEach(
      (k) => !k.includes(AUTH_TOKEN_NAME) && window.localStorage.removeItem(k),
    )
  } catch {
    await Promise.resolve()
  }
  try {
    window.sessionStorage.clear()
  } catch {
    await Promise.resolve()
  }
  if (typeof window.caches !== 'undefined') {
    try {
      const keys = await window.caches.keys()
      await Promise.all(
        keys.map(
          (k) => !k.includes(AUTH_TOKEN_NAME) && window.caches.delete(k),
        ),
      )
    } catch {
      await Promise.resolve()
    }
  }
  if (typeof window.indexedDB !== 'undefined') {
    const idb = window.indexedDB as unknown as {
      databases?: () => Promise<Array<{ name?: string }>>
      deleteDatabase: (name: string) => IDBOpenDBRequest
    }
    if (typeof idb.databases === 'function') {
      try {
        const dbs = await idb.databases()
        await Promise.all(
          (dbs || []).map((db) => {
            if (!db || !db.name) return Promise.resolve()
            return new Promise<void>((resolve) => {
              const req = idb.deleteDatabase(db.name as string)
              req.onsuccess = () => resolve()
              req.onerror = () => resolve()
              req.onblocked = () => resolve()
            })
          }),
        )
      } catch {
        await Promise.resolve()
      }
    }
  }
}

export const handleWlsyVersionChange = async () => {
  const currentVersion = wlsly()?.platformData?.toolbarBuild?.toString()
  const version = storage.getItem('version')

  if (version && currentVersion && version !== currentVersion) {
    await clearAllStorage()
    window.location.reload()
  } else if (!version && currentVersion) {
    storage.setItem('version', currentVersion)
  }
}
